import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import CargarArchivo from './cargar-archivo';
import CargasPrevias from './cargas-previas';

const CargaEmisionPagosCIA = () => {

  return (
    <Container>
      <Card className='mt-2'>
        <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >Carga de Pagos Emitidos CIA (*)</Card.Header>
        <Card.Body>
          <CargarArchivo />
          <CargasPrevias/> 
        </Card.Body>
      </Card>
    </Container>
  )
}
export default CargaEmisionPagosCIA
